<div
    class="border-neutral-variant-40/40 xl:max-w-auto h-full max-w-91.5 min-w-91.5 cursor-pointer rounded-lg border py-6 lg:min-w-0"
    tabindex="0"
    role="button"
    (click)="getSuppliersBySubcategory(subcategory().id)"
>
    <figure class="flex flex-col justify-center gap-4">
        <img
            draggable="false"
            width="250"
            height="250"
            class="place-self-center object-contain"
            [ngSrc]="subcategory().image | getDirectusImage"
            [alt]="subcategory().translations_refs | getTranslation: 'title'"
        />
        <figcaption class="text-title-medium px-4 text-center">
            {{ subcategory().translations_refs | getTranslation: "title" }}
        </figcaption>
    </figure>
</div>
